<style src="./ButtonSubmit.scss" lang="scss" scoped></style>
<template>
  <div class="button-submit">
    <div class="button-submit" v-if="state === 'REPOSE'">
      <button
        class="btn-success">
        <component :is="iconSave" />
        {{ label }}
      </button>
    </div>
    <div class="btn button-wait" v-if="state === 'WAIT'">
      <icon-wait />
      {{ label }}
    </div>
    <div class="btn button-disabled" v-if="state === 'DISABLED'">
      <icon-lock />
      {{ label }}
    </div>
  </div>
</template>

<script>
import { IconWait, IconLock } from '@/components/primitives/icons'

export default {
  name: 'ButtonSubmit',
  components: {
    IconWait,
    IconLock
  },
  props: {
    state: {
      default: 'REPOSE'
    },
    label: {
      default: 'Enviar'
    },
    iconSave: {
      default: null
    }
  },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/button-submit/ButtonSubmit.vue